import { helpers } from 'vuelidate/lib/validators';

export default value => {
  return (
    !helpers.req(value) ||
    ((String(value).startsWith('https://www.youtube.com') || String(value).startsWith('https://youtube.com')) &&
      new URLSearchParams(String(value).split('?')[1]).get('v') !== null) ||
    (String(value).startsWith('https://youtu.be/') && value.split('.be/')[1].split('?')[0])
  );
};
